<template>
    <div>
        <div class="searcher-container-negative mb-5">
            <select @change="filtrarPorOrden($event)" name="company-filter" id="company-filter"
                class="form-control py-2 px-4 w-auto border-dark">
                <option value="0">Ordenar por</option>
                <option value="nameAsc">Nombre de la Empresa A-Z</option>
                <option value="nameDesc">Nombre de la Empresa Z-A</option>
                <option value="studentsAsc">Menos Usuarios</option>
                <option value="studentsDesc">Más Usuarios</option>
            </select>
            <v-text-field v-model="search" label="Busca por nombre de Empresa" class="searcher form-control form-search px-2"
                single-line hide-details></v-text-field>
        </div>

        <v-data-table :headers="headersTabs" :items="desserts" item-key="name" :search="search" :items-per-page="5"
            class="elevation-1 table table-companies text-center align-middle small" loading loading-text="Cargando..."
            mobile-breakpoint="0"
            :footer-props="{
                prevIcon: 'fa-solid fa-chevron-left',
                nextIcon: 'fa-solid fa-chevron-right',
                'items-per-page-text': 'Mostrando: ',
                'items-per-page-options': [5, 10, 20, 30, 40, 50]
            }">
            <template v-slot:item="row">
                <tr>
                    <td>{{ row.item.id }}</td>
                    <td>
                        <div class="text-start ps-lg-4" style="width: 200px;">
                            {{ row.item.name }}
                        </div>
                    </td>
                    <td><a :href="redirect+'?client='+row.item.id">{{ row.item.users ? row.item.users.length : 0 }}</a></td>
                    <td>{{ row.item.statistics ? row.item.statistics.courses_started : 0 }}</td>
                    <td>{{ row.item.statistics ? row.item.statistics.courses_completed : 0 }}</td>
                    <td>{{ row.item.statistics ? row.item.statistics.failed_courses : 0 }}</td>
                    <td>{{ row.item.statistics ? row.item.statistics.registered_routes : 0 }}</td>
                    <td>{{ row.item.statistics ? row.item.statistics.routes_completed : 0 }}</td>
                    <td>{{ row.item.statistics ? row.item.statistics.insignia : 0 }}</td>
                    <td>{{ row.item.statistics ? row.item.statistics.failed_routes : 0 }}</td>
                    <td>{{ row.item.hability ? "Activa" : "Inactiva" }}</td>
                    <td width="20%">
                        <div class="d-flex align-items-center justify-content-start">
                            <div v-if="row.item.hability">
                                <a @click="changeClients(row.item)" type="button" class="text-primary me-1"
                                    alt="Deshabilitar" title="Deshabilitar">
                                    <!-- Deshabilitar -->
                                    <i class="fa-solid fa-user fs-5"></i>
                                </a>
                            </div>
                            <div v-else>
                                <a @click="changeClients(row.item)" type="button" class="text-primary me-1"
                                    alt="Habilitar" title="Habilitar">
                                    <!-- Habilitar -->
                                    <i class="fa-regular fa-user fs-5"></i>
                                </a>
                            </div>
                            <a type="button" class="text-secondary" data-bs-toggle="modal" data-bs-target="#updateModal"
                                @click="editarModal(row.item)">
                            </a>
                            &nbsp;
                            <a type="button" class="text-primary me-1" data-bs-toggle="modal"
                                data-bs-target="#updateModal" @click="editarModal(row.item)" alt="Editar este cliente"
                                title="Editar este cliente">
                                <i class="fa-solid fa-edit fs-5"></i>
                            </a>
                            &nbsp;
                            <a type="button" class="text-primary me-1" alt="Eliminar este cliente"
                                title="Eliminar este cliente" data-bs-toggle="modal" data-bs-target="#deleteModal"
                                @click="destroy = row.item">
                                <i class="fa-solid fa-trash fs-5"></i>
                            </a>
                            <div v-html="row.item.showClient"></div>
                        </div>
                    </td>
                </tr>
            </template>
        </v-data-table>

        <!--modal delete client-->
        <div class="modal fade" id="deleteModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="deleteModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title">
                            Eliminar administrador {{ destroy.name }}
                        </h5>
                    </div>
                    <div class="modal-body text-center">
                        <span id="response">¿Esta seguro de eliminar el administrador
                            {{ destroy.name }}?</span>
                    </div>
                    <div class="modal-footer">
                        <button id="close" type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal"
                            @click="destroy = []">
                            Cerrar
                        </button>
                        <button id="delete" type="button" @click="eliminarCliente" class="btn btn-outline-danger">
                            Eliminar administrador
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!--modal edit client-->
        <div class="modal fade" id="updateModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="updateModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title">
                            Actualización del cliente
                        </h5>
                    </div>
                    <div class="modal-body">
                        <div class="rounded-8">
                            <div class="title-dark">
                                Información de la empresa
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group row align-items-center">
                                        <div class="col-md-6">
                                            <label for="client-logo" class="form-label">Logo Cliente</label>
                                            <div>
                                                <img :src="edit.photo" ref="profilePhotoDisplay" class="w-50px"
                                                    style="max-height:130px;" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <input id="photo" v-on:change="attachImage" ref="profilePhoto" type="file"
                                                class="form-control" style="padding: 4.5em;">
                                            <p class="lh-sm mt-2 small text-dark"><small>Se recomienda 300px X 300px.
                                                    Formatos compatibles JPG, JPEG y PNG</small></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="client-name" class="form-label">Nombre de la Empresa</label>
                                                <input type="text" v-model="edit.name" class="form-control"
                                                    placeholder="Nombre del cliente" aria-label="Nombre del cliente"
                                                    id="client-name" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="client-website" class="form-label">Sitio Web</label>
                                                <input type="text" v-model="edit.website" class="form-control"
                                                    placeholder="Sitio Web" aria-label="Sitio Web"
                                                    id="client-website" />
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div>
                                <div class="title-dark mt-3">
                                    Nivel del plan empresarial
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <select @change="revisarLicenciaXCliente($event, edit.id)"
                                                v-model="edit.license_id" class="form-control" id="client-plan">
                                                <option value="" disabled selected>Seleccione una licencia</option>
                                                <option v-for="r of licencia" :key="r.id" :value="r.id"
                                                    :data-users="r.accepted_users" :data-routes="r.accepted_routes"
                                                    :data-courses="r.accepted_courses">
                                                    {{ r.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="title-dark mt-3">
                                    Etapa de la Empresa:
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <select v-model="edit.etapa_empresa" class="form-control" id="client-etapa">
                                                <option value="">Seleccione etapa...</option>
                                                <option value="free_trial">Free Trial</option>
                                            <option value="pago">Pago</option>
                                        </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button id="cancel" type="button" class="d-flex text-primary fw-500 align-items-center lh-1" data-bs-dismiss="modal"
                            @click="edit = []">
                            Cerrar
                        </button>
                        &nbsp;
                        &nbsp;
                        <button id="update" disabled type="button" @click="editarCliente" class="btn btn-utel">
                            Actualizar cliente
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Button trigger modal confirmación elimina -->
        <button id="succesDeleteBtn" type="button" class="btn btn-primary invisible" data-bs-toggle="modal"
            data-bs-target="#succesDelete">
        </button>

        <!-- Modal Confirmación Elimina -->
        <div class="modal fade" id="succesDelete" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="succesDeleteLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title" id="succesDeleteLabel">Eliminado</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-center">
                        Se ha eliminado <br> correctamente la empresa
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary text-light"
                            data-bs-dismiss="modal">Aceptar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["get", "headertab", "licences", "update", "photoupdate", "urlupgradehability", "urlrevisarplan",'redirect'],
    data() {
        return {
            search: '',
            headersTabs: this.headertab,
            url: this.get,
            licencia: this.licences,
            userClient: this.userClient,
            desserts: [],
            edit: [],
            destroy: [],
            accepted_users: 0,
            id_license: 0,
            accepted_courses: 0,
            accepted_routes: 0,
            newClient: { name: "", licencia: '' },
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            const search = location.search;
            const params = new URLSearchParams(search);
            const lic = params.get('lic');
            let p = '?withUsers=true';
            if(lic) p += '&lic='+lic;
            axios.get(this.url + p).then((res) => {
                this.desserts = res.data;
            });
        },
        editarCliente() {

            const config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }
            let btn = document.getElementById("update");
            let cancel = document.getElementById("cancel");
            let modal = document.getElementById("updateModal");
            let bd = document.getElementsByClassName("modal-backdrop");

            // cancel.setAttribute("disabled", "disabled");
            // btn.setAttribute("disabled", "disabled");

            btn.textContent = "Procesando ...";
            axios
                .put(this.update, this.edit)
                .then((res) => {
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        this.getData();
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                    }, 500);
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        eliminarCliente() {
            const response = document.getElementById("response");
            let btn = document.getElementById("delete");
            let cancel = document.getElementById("close");
            let modal = document.getElementById("deleteModal");
            let bd = document.getElementsByClassName("modal-backdrop");
            let succesDeleteBtn = document.getElementById('succesDeleteBtn');
            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios
                .delete(this.url + "/" + this.destroy.id)
                .then((res) => {
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        this.getData();
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        btn.textContent = "Actualizar cliente";
                        succesDeleteBtn.click();
                    }, 500);
                })
                .catch((err) => {
                    console.log(err.error);
                    response.outerText = "Error al eliminar datos";
                    cancel.removeAttribute("disabled");
                    btn.setAttribute("style", "display:none");

                    setTimeout(() => {
                        btn.removeAttribute("disabled");
                        btn.removeAttribute("style");
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        window.location.reload();
                    }, 1000);
                });
        },
        agregarCliente() {
            let btn = document.getElementById("agregar");
            let cancel = document.getElementById("closeAdd");
            let modal = document.getElementById("addModal");
            let bd = document.getElementsByClassName("modal-backdrop");
            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios
                .post(this.url, this.newClient)
                .then((res) => {
                    this.newClient = { name: "" };
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        this.getData();
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                    }, 500);
                })
                .catch((err) => { });
        },
        attachImage() {

            const config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }

            this.edit.photo = this.$refs.profilePhoto.files[0];
            let reader = new FileReader();
            reader.addEventListener('load', function () {
                this.$refs.profilePhotoDisplay.src = reader.result;
            }.bind(this), false);
            reader.readAsDataURL(this.edit.photo);

            var data = new FormData();
            data.append('file', this.edit.photo);
            data.append('idClient', this.edit.id);

            axios
                .post(this.photoupdate, data, config)
                .then((res) => {
                    this.edit.photo = res.data;
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        editarModal(item) {
            this.accepted_users = item.licence.accepted_users;
            this.accepted_routes = item.licence.accepted_routes;
            this.accepted_courses = item.licence.accepted_courses;
            this.edit = item;
        },
        changeClients(item) {
            axios
                .post(this.urlupgradehability, item)
                .then((res) => {
                    this.getData();
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        filtrarPorOrden(val) {
            const value = val.target.value;
            axios.get(`${this.url}?withUsers=true&filterOrder=${value}`).then((res) => {
                this.desserts = res.data;
            });
        },
        revisarLicenciaXCliente(event, idCliente) {
            const value = event.target.value;
            let btn = document.getElementById("update");

            axios.post(`${this.urlrevisarplan}?withUsers=true&idPlan=${value}&idCliente=${idCliente}`).then((res) => {
                btn.removeAttribute("disabled");
            }).catch((err) => {
                if (!err.response) return
                btn.setAttribute("disabled", "disabled");
                this.$swal(err.response.data.message);
            });
        },
    }
}
</script>
